import React from "react";

const BookingDetailsSkeleton: React.FC = () => {
  return (
    <div className="w-full lg:w-1/2 lg:mr-6">
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8 animate-pulse">
        {/* Skeleton for heading */}
        <div className="h-8 bg-gray-300 dark:bg-gray-700 rounded w-2/3"></div>

        {/* Skeleton for GuestyPaymentSDK/Reservation Details */}
        <div className="space-y-6">
          {/* Subheading */}
          <div className="h-6 bg-gray-300 dark:bg-gray-700 rounded w-1/3"></div>

          {/* Divider */}
          <div className="h-px bg-gray-300 dark:bg-gray-700"></div>

          {/* Reservation Details */}
          <div className="flex flex-col space-y-4">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="flex justify-between items-center">
                <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-1/3"></div>
                <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-1/4"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Skeleton for button */}
        <div className="h-12 bg-gray-300 dark:bg-gray-700 rounded w-1/2"></div>
      </div>
    </div>
  );
};

export default BookingDetailsSkeleton;